<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/152/base.png" alt="" />
      <div class="technological-process">
        <div class="zccl">
          <img class="top" src="./../assets/imgs/151/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            具有良好职业道德，无不良信用记录，符合条款支持规定，与青羊辖区企（事）业单位签订劳动合同或聘用合同，并按规定缴纳社会保险的人员（劳动合同签订单位与社会保险缴纳单位须一致）。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/151/title2.png" alt="" />
          <div class="content">
            <div style="font-weight: 600; font-size: 0.3rem">
              须同时满足以下条件：
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （一）2022年11月20日（含）起进入青羊区工作，从事岗位在《青羊区主导产业急需紧缺人才专业目录》中，以签订劳动合同时有效目录为准，且符合该岗位对应的专业及学历要求；
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）全日制高校应届毕业生，毕业证记载时间（含）起至线上申报当日不超过1年；
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）申报人未在本区享受过人才安居及住房保障等政策；
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （四）与青羊辖区企（事）业单位（工商注册地、单位纳税关系、统计义务在本区）签订劳动合同或聘用合同3年（含）以上，或自主创办企业并担任法定代表人，按规定缴纳社会保险半年（含）以上（劳动合同签订单位与社会保险缴纳单位须一致）；
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （五）申报人本人、配偶、未成年子女（或其他法定抚养义务人）在成都市内无自有产权住房。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/151/title3.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （一）给予本科学历学位应届毕业生0.6万元一次性租房补贴。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）给予硕士学历学位应届毕业生1.2万元一次性租房补贴。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）给予博士学历学位应届毕业生3万元一次性租房补贴。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/151/title4.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0.2rem">
              <div>
                登录“青睐”人才智慧云平台并按网站要求提供（上传）相关材料，网址：
                https://www.qltalent.com/
              </div>
            </div>
            <div style="color: #3D5AA3;margin-top: 0.16rem;">注：如提供虚假资料、伪造证明材料、不诚信申报等不正当手段骗取补贴资金的，一经查实，将责令限期退还违规领取的补贴资金，并依法依纪追究责任。</div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="./../assets/imgs/149/title5.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-87703885">028-87703885</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              青羊区住建交局住保科
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="info" src="../assets/imgs/148/code.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-84080490"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.part-two-title-img {
  width: 7.03rem;
  height: 1.37rem;
  top: 0;
  left: -0.2rem;
  position: absolute;
}

.part-two {
  margin-left: 0.02rem;
  width: 6.85rem;
  margin-top: 0.22rem;
  background: #e8eeff;
  border-radius: 0.16rem;
  padding-left: 0.25rem;
  padding-right: 0.3rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;

  .part-two-title {
    text-align: left;
    margin-left: 0.33rem;
    margin-bottom: 0.22rem;

    &::before {
      position: absolute;
      content: "";
      width: 0.28rem;
      height: 0.28rem;
      border-radius: 50%;
      background: none;
      border: 0.06rem solid #ff6d60;
      box-sizing: border-box;
      top: 0.08rem;
      left: -0.35rem;
    }
  }

  .part-two-items {
    width: 6.35rem;
    padding-bottom: 0.35rem;
    background: #ffffff;
    border-radius: 10px;
    padding: 0.31rem;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 0.22rem;
  }
  .part-two-content {
    margin-top: 0.2rem;
    margin-bottom: 0.3rem;
    width: 6.22rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 0.34rem 0.24rem 0.15rem 0.67rem;
    font-size: 0.26rem;
    // //font-family:: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #4e4e4e;
    line-height: 0.44rem;
    text-align: left;

    .part-two-dot {
      position: absolute;
      top: 0;
      left: -0.46rem;
      width: 0.36rem;
      height: 0.36rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 0.21rem;
      background: #739bfe;
      border-radius: 50%;
    }
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-2.2rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 2.98rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
